/**
 * Penalty / shot GLB URLs only — safe to import from preload / prewarm
 * without pulling KeeperStanding, FootballGoal, etc. into the graph.
 */

/** User-provided football — public/model/football_model.glb */
export const FOOTBALL_GLB_URL = '/model/football_model.glb';

/** Full-quality goal — quantized bake made the net jaggy. */
export const FOOTBALL_GOAL_GLB_URL = '/model/football_goal_post.glb';

/** Standing goalkeeper — static optimized bake of goalkepper standing.glb */
export const KEEPER_STANDING_GLB_URL =
  '/model/goalkepper_standing_optimized.glb?v=pose2';

/** Mixamo dive to the keeper's right (+X) — public/model/golli dive.glb */
export const KEEPER_DIVE_RIGHT_GLB_URL = encodeURI('/model/golli dive.glb');

/**
 * Mirrored dive to the keeper's left (−X).
 * Generated from the right dive via tools/mirror-keeper-dive.mjs
 * (Left/Right bone swap + YZ plane mirror).
 */
export const KEEPER_DIVE_LEFT_GLB_URL = encodeURI(
  '/model/golli dive left.glb',
);
